import { TrackingDispatchEvent } from '@/shared/infrastructure/context/TrackingContext';
import { onDispatch } from '@/shared/infrastructure/context';

export const trackingService = () => {
  const dispatch = ({ event, interaction = true, ...trackingEvent }: TrackingDispatchEvent) => {
    onDispatch({
      ...trackingEvent,
      event,
      interaction,
      appName: 'b2b-authentication-app',
      timestamp: new Date().getTime(),
    });
  };

  return dispatch;
};
